<template>
  <div>
    <main class="content container">
      <div class="content__top">
        <ul class="breadcrumbs">
          <li class="breadcrumbs__item">
            <a class="breadcrumbs__link" href="index.html"> Каталог </a>
          </li>
          <li class="breadcrumbs__item">
            <a class="breadcrumbs__link"> Корзина </a>
          </li>
        </ul>

        <h1 class="content__title">Корзина</h1>
        <span class="content__info"> {{ countProducts }} товара </span>
      </div>

      <section class="cart">
        <form class="cart__form form" action="#" method="POST">
          <div class="cart__field">
            <img
              class="spinner"
              src="@/assets/Spinner-3.gif"
              alt="Загрузка количества товаров ..."
              v-show="cartLoading"
            />
            <ul class="cart__list">
              <CartItem v-for="item in items" :key="item.productId" :item="item" />
            </ul>
          </div>

          <div class="cart__block">
            <p class="cart__desc">Мы&nbsp;посчитаем стоимость доставки на&nbsp;следующем этапе</p>
            <p class="cart__price">
              Итого: <span>{{ totalPrice | numberFormat }} ₽</span>
            </p>

            <router-link
              v-if="items.length"
              tag="button"
              :to="{ name: 'order' }"
              class="cart__button button button--primery"
              type="submit"
            >
              Оформить заказ
            </router-link>
          </div>
        </form>
      </section>
    </main>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import CartItem from '@/components/CartItem.vue';
import numberFormat from '@/helpers/numberFormat';

export default {
  components: { CartItem },

  filters: { numberFormat },

  props: ['cartLoading'],

  computed: {
    ...mapGetters({
      items: 'cartDetailProducts',
      totalPrice: 'cartTotalPrice',
      countProducts: 'cartCountProducts',
    }),
  },
};
</script>
